import React from 'react';
import PropTypes from 'prop-types';

const GoodNeighborPolicyPage = ({ data }) => {

  return (
    <div style={{ fontFamily: "Elef Layla MF", padding: "20px", maxWidth: "800px", margin: "0 auto", lineHeight: "1.2",fontSize: "16pt",height: "1200px" }}>
      <div style={{ textAlign: "center" }}>
        <h2
          style={{
            display: "inline-block",
            fontSize: "20pt",
            fontFamily: "Elef Layla MF",
            marginBottom: "15px",
            borderBottom: "2px solid black",
            paddingBottom: "0px",
          }}
        >
            Good Neighbor Policy
        </h2>
      </div>
      

      {/* Policy Content */}
      <div style={{ marginBottom: '20px' }}>
        <p style={{ marginBottom: '15px' }}>
          Legacy Healing Center Margate, LLC feels it is imperative that every client and employee remain considerate to our neighbors. It is expected that all residents be courteous and greet neighbors, however, the nature of your stay/living arrangements is to be kept confidential. Any personal conduct that negatively affects our relationship with neighbors and the surrounding community will not be tolerated.
        </p>

        <p style={{ marginBottom: '15px' }}>
          It is expected that all residents smoke only in designated areas, refrain from loitering outside of housing locations, keep all noise, lewd and offensive language/behavior at a minimum. It is the responsibility of all residents to maintain the cleanliness both in and outside of housing locations and in any surrounding public spaces.
        </p>

        <p style={{ marginBottom: '15px' }}>
          If at any time an issue arises between a resident of Legacy Healing Center Margate, LLC and a neighbor, the neighbor is to be given the name and contact number of the Director of Housing and/or the CRRA as opposed to a resident attempting to try to resolve the complaint by themselves.
        </p>

        <p style={{ marginBottom: '15px' }}>
          Residents will only park in designated parking spots. Residents must never block other neighbors' driveways, mailboxes or garbage cans.
        </p>

        <p style={{ marginBottom: '15px', fontWeight: 'normal' }}>
          Repeated infractions may lead to termination from Legacy Healing Center Margate recovery residences.
        </p>
      </div>
    </div>
  );
};

GoodNeighborPolicyPage.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired
};

export default GoodNeighborPolicyPage;